module.exports = __webpack_public_path__ + "static/media/integrify.4e316477.png";